import {InitLiquid} from "./includes/shadowgrapher-liquid";
import {equalizeHeights} from "../components/utility/equalize-heights";
import {InitBalloons} from "./includes/shadowgrapher-balloons";


function init() {
    // console.log( "shadowgrapher.js loaded", { InitLiquid } );
    InitLiquid( {
        color: "#000000",
        canvas: document.getElementById( 'liquidCanvas' )
    } );

    InitBalloons( {
        selector: ".Decoration--balloon"
    } );

    // Equalize QoL card title heights for better aesthetics, but only on wider screens where the layout allows for it
    const qolHeaders = [ ...document.querySelectorAll( ".QoLCard-header" ) ];
    if ( qolHeaders.length ) {
        equalizeHeights( qolHeaders, { useMinHeight: 1280 } );
    }
}

// Run when the DOM is ready
// Check if `window.onload` has already fired
if (document.readyState === "complete") {
    init(); // Page is already fully loaded, run immediately
} else {
    window.onload = init; // Otherwise, wait for `window.onload`
}